module.exports = __webpack_public_path__ + "img/slider-people-6.67494866.png";